function removeSubstring(string: string, cutString: string): string {
  return string.replace(new RegExp(cutString, 'g'), '');
}

const isString = (element: any):boolean => typeof element === 'string';

const capitalize = (text:string):string => `${text.charAt(0).toUpperCase()}${text.slice(1).toLowerCase()}`;

const upperCaseFirst = (text: string): string => `${text.charAt(0).toUpperCase()}${text.substring(1)}`;

export { capitalize, isString, removeSubstring, upperCaseFirst };
